import { Request } from '@/classes/Request.ts'

export interface LoggedInResponse {
  loggedIn: boolean
  familyUserId: null | number
  sessionExpiresAt: null | number
  sessionIdleAt: null | number
  sessionTimeoutInterval: null | number
  localeCode: string
}

/**
 * Returns basic information about the user
 */
export const loggedIn = async (): Promise<LoggedInResponse> => {
  return new Promise<LoggedInResponse>(async resolve => {
    const response = await new Request().get('/ajax/logged_in')

    if (response.data.family_user_id === null) {
      resolve({
        loggedIn: false,
        familyUserId: null,
        sessionExpiresAt: null,
        sessionIdleAt: null,
        sessionTimeoutInterval: null,
        localeCode: 'en'
      } as LoggedInResponse)
    }

    resolve({
      loggedIn: true,
      familyUserId: response.data.family_user_id,
      sessionExpiresAt: Date.parse(response.data.session_expires_at),
      sessionIdleAt: Date.parse(response.data.session_idle_at),
      sessionTimeoutInterval: Number(response.data.session_timeout_interval),
      localeCode: response.data.locale_code
    } as LoggedInResponse)
  })
}
